import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dash",
  "use": "dash-usage",
  "viewBox": "0 0 29 3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 3\" id=\"dash\"><path fill=\"none\" stroke=\"#4A4A4A\" stroke-linecap=\"round\" stroke-width=\"3\" d=\"M2.305 1.5h25\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol